export const DEFAULT_KAFALA_PAGE = {
  banner: 'فرص تبرع لكفالة الأيتام والمساهمة في توفير حياة مستقرة لهم.',
  conditionsTitle: 'شروط الكفالة المعتمدة من اللجنة الإشرافية',
  conditions: [
    {
      title: 'أداء مبلغ الكفالة:',
      text: 'أداء مبلغ الكفالة المتفق عليه، وهو 700 درهم مغربي عند بداية كل شهر ميلادي، والذي يكون مساهمة في تلبية احتياجاته الضرورية من طعام وشراب ولباس ودراسة.',
    },
    {
      title: 'الدعم المستمر:',
      text: 'ألتزم بتقديم الدعم المستمر لليتيم المكفول، إلى غاية البلوغ أو سن 16 سنة، وعدم التوقف عن ذلك إلا للضرورة القصوى.',
    },
    {
      title: 'التواصل الدائم:',
      text: 'أتعهد بالتواصل الدائم مع جمعية صحبة الخير لمتابعة حالة اليتيم واحتياجاته.',
    },
    {
      title: 'احترام خصوصية اليتيم:',
      text: 'أتعهد بعدم الكشف عن أي معلومات شخصية أو خاصة تتعلق باليتيم المكفول دون موافقته وموافقة جمعية صحبة الخير.',
    },
  ],
};

export const resolveKafalaPageContent = (program) => {
  const conditions = Array.isArray(program?.kafala_conditions)
    ? program.kafala_conditions.filter((item) => item?.title || item?.text)
    : [];

  return {
    banner: (program?.kafala_banner_text || '').trim() || DEFAULT_KAFALA_PAGE.banner,
    conditionsTitle: (program?.kafala_conditions_title || '').trim() || DEFAULT_KAFALA_PAGE.conditionsTitle,
    conditions: conditions.length ? conditions : DEFAULT_KAFALA_PAGE.conditions,
  };
};
